module.exports = __webpack_public_path__ + "static/media/shield.4190f32a.svg";